import { ThemeOptions } from "@material-ui/core";

const themeNRC: ThemeOptions = {
	palette: {
		primary: {
			main: "#ff7602",
		},
		text: {
			primary: "#000",
		},
	},
};

const themeIFRC: ThemeOptions = {
	palette: {
		primary: {
			main: "#ed1b2e",
		},
		text: {
			primary: "#6D6E70",
		},
	},
};

export const GenerateTheme = (themeName: string) => {
	return themeName === "IFRC" ? themeIFRC : themeNRC;
};
